export const FIDUCIARIES = Object.freeze({
  MONRNINGSTAR: 'Morningstar',
  RJ: 'Raymond James',
  UBS: 'UBS',
});
export const USER_ROLES = Object.freeze({
  CONSULTANT: 'FIDUCIARYSERVICES_CONSULTANT',
  OPERATIONS: 'FIDUCIARYSERVICES_OPERATIONS',
});
export const FUND_STATUSES = Object.freeze({
  1: 'Approved',
  2: 'Removed',
  3: 'OnWatch',
  4: 'None',
});
